import React from 'react';
import css from './CareProvider.module.css';
import {
  H3,
  Paragraph,
  PhoneLink,
  ProviderImage,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
} from '../../../core';
import { ProviderDetails } from '../../../api/models';
import { PhoneUtility } from '@mchs/web-core';

interface CareProviderProps {
  providerName: string;
  facilityPhoneNumber: string;
  providerDetails?: ProviderDetails;
}

const CareProvider: React.FC<CareProviderProps> = (
  props: CareProviderProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <H3 text="CARE PROVIDER" />
      <StackedRow>
        <div className={css.providerImageContainer}>
          <ProviderImage
            cattailsProviderNumber={props.providerDetails?.cattailsProviderId}
          />
        </div>
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <Paragraph text={props.providerName} />
          <PhoneLink
            phoneNumber={PhoneUtility.cleanPhone(props.facilityPhoneNumber)}
          />
        </StackedColumn>
      </StackedRow>
    </StackedColumn>
  );
};

export default CareProvider;
